import React from 'react';
import { IconButton, Stack } from '@mui/material';
import { IconFullScreenSolid, IconCollapseSolid } from '@roku-web-ui/rds-icons';
import { colors } from '@roku-web-ui/rds-theme';

import { Tooltip } from 'components/common/Tooltip';
import { useAspenLogger } from 'hooks/useAspenLogger';
import { dispatchEvent } from 'modules/globalEvents';

import { AppDeviceLeaf } from 'types/common/leaf';

interface FullscreenProps {
  leafId: AppDeviceLeaf['id'];
  fullscreenEnabled: boolean;
}

export const Fullscreen = ({ leafId, fullscreenEnabled }: FullscreenProps) => {
  const { logAspenEvent } = useAspenLogger();

  return (
    <Tooltip title={`${fullscreenEnabled ? 'Exit' : 'Enter'} fullscreen`} placement="top">
      <IconButton
        aria-label="fullscreen"
        data-testid="button-fullscreen"
        onClick={() => {
          dispatchEvent({
            leafId,
            event: 'TOGGLE_FULLSCREEN',
            data: { newValue: !fullscreenEnabled },
          });

          logAspenEvent({
            log_id: 'iot.web.stream.interaction',
            payload: {
              device_id: leafId,
              interaction: 'fullscreen',
            },
          });
        }}
        sx={{
          '&:hover': {
            boxShadow: 'none',
          },
        }}
      >
        <Stack direction="column" spacing={0} alignItems="center">
          {fullscreenEnabled ? (
            <IconCollapseSolid sx={{ color: colors.grey[400] }} />
          ) : (
            <IconFullScreenSolid sx={{ color: colors.grey[400] }} />
          )}
        </Stack>
      </IconButton>
    </Tooltip>
  );
};
